import { DataLogRq, SourcePage } from '@domain/rq/DataLog';
import { ProfileProjectVO } from '@domain/vo/profile/ProfileProjectVO';
import { ProjectType } from '@domain/constant/profile/ProjectType';
import { SkillLevelType } from '@domain/constant/profile/SkillType';
import DateFormat from '@utils/date/format';

export class ProfileProjectSaveVO {
  title: string;
  startDate?: string;
  endDate?: string;
  teamType: ProjectType | null;
  contribution: number | null;
  performance: string;
  institution: string;
  skills: SkillsSaveVO[];

  constructor(vo: ProfileProjectSaveVO) {
    this.title = vo.title;
    this.startDate = DateFormat.getDateFormatString(vo.startDate, 'yyyy-MM');
    this.endDate = DateFormat.getDateFormatString(vo.endDate, 'yyyy-MM');
    this.teamType = vo.teamType;
    this.contribution = vo.contribution;
    this.performance = vo.performance;
    this.institution = vo.institution;
    this.skills = vo.skills.map((skill) => new SkillsSaveVO(skill));
  }

  static convertProfileProjectSaveVO(vo: ProfileProjectVO) {
    return {
      title: vo.title,
      startDate: DateFormat.getDateFormatString(vo.startDate, 'yyyy-MM'),
      endDate: DateFormat.getDateFormatString(vo.endDate, 'yyyy-MM'),
      teamType: vo.teamType,
      contribution: vo.contribution,
      performance: vo.performance,
      institution: vo.institution,
      skills: vo.skills?.map((skill) => new SkillsSaveVO(skill)) || [],
    };
  }
}

export class SkillsSaveVO {
  code: number;
  level: SkillLevelType;

  constructor(vo: SkillsSaveVO) {
    this.code = vo.code;
    this.level = vo.level;
  }
}

export default class ProfileProjectListSaveRq {
  projects: ProfileProjectSaveVO[];
  sourcePage?: SourcePage;

  constructor(rq: ProfileProjectSaveDto) {
    this.projects = rq.projects.map((project) => new ProfileProjectSaveVO(project));
    this.sourcePage = rq.sourcePage;
  }
}

export interface ProfileProjectSaveDto extends DataLogRq {
  projects: ProfileProjectSaveVO[];
}
